import { useIsMutating } from '@tanstack/react-query';

import { ESHOP_MUTATION_KEY } from '../model';

export const useIsRatePlanMutating = () => {
    const addRatePlanIsLoading = useIsMutating({ mutationKey: [ESHOP_MUTATION_KEY.ADD_RATE_PLAN], exact: true });
    const addCartEntryIsLoading = useIsMutating({ mutationKey: [ESHOP_MUTATION_KEY.ADD_CART_ENTRY], exact: true });
    const deleteRatePlanIsLoading = useIsMutating({ mutationKey: [ESHOP_MUTATION_KEY.DELETE_RATE_PLAN], exact: true });
    const updatingContractType = useIsMutating({ mutationKey: [ESHOP_MUTATION_KEY.UPDATE_CONTRACT_TYPE], exact: true });

    return Boolean(addRatePlanIsLoading || addCartEntryIsLoading || deleteRatePlanIsLoading || updatingContractType);
};
